import { FormStep } from '../types';

export function getSpaOptionText(
  selectionGroup: Omit<FormStep, 'step' | 'type'>,
  totalGuests: number
): string | undefined {
  const { selectionsRequired, experienceType } = selectionGroup;
  if (!selectionsRequired) return;

  const totalNeeded = selectionsRequired * totalGuests;
  const isSpaFacilities = experienceType === 'spa-facilities';
  const isSpaTreatments = experienceType === 'spa-treatments';
  const isSpaClasses = experienceType === 'spa-classes';

  const isSingular = totalNeeded === 1;

  if (isSpaFacilities) {
    return isSingular ? 'facility' : 'facilities';
  }

  if (isSpaTreatments) {
    return isSingular ? 'treatment' : 'treatments';
  }

  if (isSpaClasses) {
    return isSingular ? 'activity' : 'activities';
  }
}
